<h1 class="if-menu-heading-cabinet" [class.collapsed]="isCollapsed()">
    @if (!isCollapsed()) {
        <ng-content></ng-content>
    }
</h1>